import { useRouter } from 'preact-router';

import AppOnboarding from '@/components/AppOnboarding';
import Header from '@/components/Header';
import { LayoutDetector } from '@/components/LayoutDetector';
import PageWrapper from '@/components/Main/PageWrapper';
import Redirect from '@/components/Redirect';
import ShareModal from '@/components/ShareModal/Modal';
import useHabitatTour from '@/components/TourOnboarding/useHabitatTour';
import { setQueryParams } from '@/hooks/route';
import HomeLayout from '@/layouts/Home';
import { useSelector } from '@/redux/helper';
import { selectShouldShowAppOnboarding } from '@/redux/selectors/users';
import { selectIsGuestSessionLocked } from '@/redux/slices/deviceSettings/selectors';

import Habitats from '../habitats/Habitats';
import HomeContent from './HomeContent';

const HomeDesktop = () => {
  // initialize habitat tour logic (desktop, ATM only for educators)
  useHabitatTour();
  return (
    <>
      <Header />
      <PageWrapper>
        <HomeLayout>
          <HomeContent />
        </HomeLayout>
      </PageWrapper>
    </>
  );
};

const HomeMobile = () => {
  const [{ matches }] = useRouter();
  const { mediaId } = matches ?? {};
  const isGuestSessionLocked = useSelector((state) => selectIsGuestSessionLocked(state, null));
  return (
    <>
      <Habitats />
      {isGuestSessionLocked ? null : mediaId ? (
        <ShareModal
          open
          shouldLoadPubnub
          mediaId={mediaId}
          isDrawer
          onClose={() => {
            setQueryParams({ mediaId: undefined, playlistId: undefined, type: undefined }, true);
          }}
        />
      ) : null}
    </>
  );
};

const HomeWithLayout = () => {
  const userRole = useSelector((state) => state?.user?.role);
  const isRealEmail = useSelector((state) => state?.user?.isRealEmail);
  const showShowAppOnboarding = useSelector(selectShouldShowAppOnboarding);
  const isLoggedIn = useSelector((state) => state?.user?.logged);
  if (isLoggedIn && userRole === 'user' && !isRealEmail) {
    return <Redirect to="/emailVerification" />;
  }

  if (showShowAppOnboarding) {
    return <AppOnboarding />;
  }

  return (
    <LayoutDetector
      title="Habitats"
      breakPoint={1023} // keep it as stable as possible in mobile device to prevent layout change when orientation changes
      desktop={<HomeDesktop />}
      mobile={<HomeMobile />}
    />
  );
};

export default HomeWithLayout;
